import { AnimatedContainer, AnimatedSection } from '@components/animated'
import { OfferItem } from '@features/offers/components/OfferItem'
import { SearchX } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { OfferList } from 'types/api'
import type { BaseResponse } from 'types/utils'

export function Offers(props: { offers: BaseResponse<OfferList> }) {
  const { offers } = props
  const { t } = useTranslation('offers')

  return (
    <AnimatedContainer>
      {offers.results.length ? (
        <div className="space-y-4">
          {offers.results.map((offer) => (
            <AnimatedSection key={offer.id}>
              <OfferItem offer={offer} />
            </AnimatedSection>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center gap-4 rounded-3xl border border-dashed border-ink/15 px-6 py-16 text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
            <SearchX className="h-7 w-7" />
          </span>
          <div>
            <h3 className="m-0 font-display text-lg font-bold text-ink">
              {t('noOffers')}
            </h3>
            <p className="mx-auto mt-1.5 max-w-md text-sm leading-relaxed text-muted-foreground">
              {t('noOffersDescription')}
            </p>
          </div>
        </div>
      )}
    </AnimatedContainer>
  )
}
